import { HCP_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { HCP_TYPE_OF_PRACTICE_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCP_TYPE_OF_PRACTICE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.hcp_practice_type`],
  limit: HCP_TYPE_OF_PRACTICE_FILTER_LIMIT,
});

const hcpTypeOfPracticeFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcpTypePracticeLabel',
  sourceCube: HCP_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: HCP_TYPE_OF_PRACTICE_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${HCP_CUBE_NAME}.hcp_practice_type`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.hcpTypePracticePlaceholder',
  searchable: true,
  applyFilter: typeOfPraciceFilterValue => {
    let typeOfPraciceValues: string[] = [];

    if (Array.isArray(typeOfPraciceFilterValue)) {
      typeOfPraciceValues = typeOfPraciceFilterValue.filter((entry): entry is string => typeof entry === 'string');
    } else if (typeof typeOfPraciceFilterValue === 'string') {
      typeOfPraciceValues = [typeOfPraciceFilterValue];
    }

    return {
      member: `${HCP_CUBE_NAME}.hcp_practice_type`,
      operator: 'equals',
      values: typeOfPraciceValues,
    };
  },
};

export default hcpTypeOfPracticeFilter;
